'use strict';

+function ($) {
  $.fn.popover.Constructor.DEFAULTS.placement = 'auto top';
  // $.fn.popover.Constructor.DEFAULTS.container = 'body'; // body would prevent tooltips from inheriting styles from their parents, but it disconnects positioning from page layout

  $(document)
  // Bootstrap's toggle popover fix: https://github.com/twbs/bootstrap/issues/16732#issuecomment-165229037
  .on('hidden.bs.popover', function (e) {
    $(e.target).data('bs.popover').inState.click = false;
  });

  $(document)
  // to dismiss/close a popover from inside that popover
  .on('click.bc.popover', '[data-dismiss="popover"]', function () {
    $(this).closest('.popover').data('bs.popover').$element.popover('hide');
  });

  // automatically activate popovers everywhere (specific options can be set using data-attributes on the tooltip trigger)
  $(document).popover({
    selector: '[data-toggle="popover"]'
  });

}(jQuery);



//////////////////
// WEBPACK FOOTER
// ./src/core/js/components/popover.js
// module id = 12
// module chunks = 0